import { Card, Divider, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { UserFeedbackTab } from "src/constants";
import { useUserFeedbackSettings } from "../hooks";
import { UserFeedbackGivenList } from "./UserFeedbackGivenList";
import { UserFeedbackReceivedList } from "./UserFeedbackReceivedList";

interface Props {
  userId: string;
  onClicked?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, formSubmissionGuid: string) => void;
  onDraftClicked?: (formSubmissionGuid: string, formGuid: string) => void;
}

const UserFeedbackTabs = (props: Props) => {
  const { settings, updateSettings } = useUserFeedbackSettings(props.userId);
  const [currentTab, setCurrentTab] = useState<UserFeedbackTab>(settings.tab);

  function handleChange(_: React.SyntheticEvent, tab: UserFeedbackTab) {
    setCurrentTab(tab);
    updateSettings({
      tab,
    });
  }

  return (
    <Card>
      <Tabs value={currentTab} onChange={handleChange}>
        <Tab label="Received" value={UserFeedbackTab.Received} disableRipple />
        <Tab label="Given" value={UserFeedbackTab.Given} disableRipple />
      </Tabs>

      <Divider />

      {currentTab === UserFeedbackTab.Received && (
        <UserFeedbackReceivedList
          userId={props.userId}
          onClicked={props.onClicked}
          onDraftClicked={props.onDraftClicked}
        />
      )}

      {currentTab === UserFeedbackTab.Given && (
        <UserFeedbackGivenList
          userId={props.userId}
          onClicked={props.onClicked}
          onDraftClicked={props.onDraftClicked}
        />
      )}
    </Card>
  );
};

export { UserFeedbackTabs };
